<template>
  <div class="cursor-pointer job-comment-counter">
    <div @click.prevent="open" ref="counter">
      <slot></slot>
    </div>

    <div ref="popperContainer">
      <template v-if="show">
        <div
            ref="popper"
            class="absolute card card-fancy job-comment-counter-card"
            :class="{ 'p-0': !loaded }"
        >
          <div class="card-outside-xy">
            <div data-popper-arrow></div>
            <job-comment-list
              :job-id="jobId"
              :job-deleted="jobDeleted"
              :user="user"
              :change-comment="changeComment"
              @loaded="onLoaded"
              @change="$emit('change', $event)"
            ></job-comment-list>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import JobCommentList from './Index.vue';
import { createPopper } from '@popperjs/core';

export default {
  name: "JobCommentCounter",

  components: {
    JobCommentList
  },

  props: {
    user: {
      type: Object,
      required: true,
    },

    jobId: {
      type: Number,
      required: true,
    },

    changeComment: {
      type: Boolean,
      default: true,
    },

    jobDeleted: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      show: false,
      popper: null,
      loaded: false,
    }
  },

  mounted() {
    document.addEventListener('click',  (e) => {
      if (
        !e.target.classList.contains('job-comment-counter-card') && !e.target.closest('.job-comment-counter-card') &&
        !e.target.classList.contains('job-comment-counter') && !e.target.closest('.job-comment-counter') &&
        !e.target.classList.contains('swal2-container') && !e.target.closest('.swal2-container')
      ) {
        this.close();
      }
    });
  },

  methods: {
    close() {
      if (this.popper) {
        this.popper.destroy();
      }

      try {
        this.$refs.popperContainer.appendChild(this.$refs.popper);

        this.loaded = false;
        this.show = false;

        this.$emit('close');
      } catch (e) {
        //
      }
    },

    setPopper () {
      if (this.popper) {
        this.popper.destroy();
      }

      this.popper = createPopper(this.$refs.counter, this.$refs.popper, {
        placement: 'left-start',
        strategy: 'absolute',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [-10, 20],
            },
          },
          {
            name: 'arrow',
          },
          {
            name: 'preventOverflow',
            enabled: false,
            options: {
              boundary: document.body,
              altBoundary: true,
              rootBoundary: 'window',
            }
          },
        ],
      });
    },

    async open(evt) {
      this.show = true;

      this.$emit('open');

      await this.$nextTick();

      setTimeout(() => {
        document.body.appendChild(this.$refs.popper);

        this.setPopper();
      }, 100);



      document.onkeydown = (evt) => {
        evt = evt || window.event;
        if (evt.keyCode === 27) {
          this.close();
        }
      };
    },

    onLoaded() {
      this.loaded = true;
      setTimeout(() => {
        this.popper.forceUpdate()
      }, 100);

    }
  },
}
</script>

<style>
  [data-popper-arrow] {
    right: -8px;
    border-top: 8px solid #0000;
    border-bottom: 8px solid #0000;
    border-left: 8px solid #e0e0e0;
  }

  .comments-tab-content {
    max-height: 300px;
    overflow: scroll;
  }

  .job-comment-counter-card {
    background-color: #fff;
    width: 500px;
    max-width: 50vw;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/Job/Comments/Counter.vue